import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { LoginService } from '../../login/login.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import moment from 'moment';
import { Nullable } from 'primeng/ts-helpers';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { GuardShift } from '../_types/guard-shift';
import { GuardsShiftsService } from '../_services/guards-shifts.service';
import { GuardsShiftsDatesService } from '../_services/guards-shifts-dates.service';
import { CalendarEventModalComponent } from '../../calendars/detail/event-modal/calendar-event-modal.component';

@Component({
    selector: 'app-guards-shifts-detail',
    templateUrl: './guards-shifts-detail.component.html',
    styleUrls: ['./guards-shifts-detail.component.css'],
    standalone: false
})
export class GuardsShiftsDetailComponent implements OnInit {

  public guardShiftFormGroup!: RxFormGroup;

  public guardShift: GuardShift = new GuardShift();
  public guardShiftDates: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  public activeIndex: number = 1;
  public color: string | undefined;
  //public totalRecordsCalendar: number = 0;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public fromDate: any = null;
  public toDate: any = null;
  public rangeStartDate: any = null;
  public rangeEndDate: any = null;
  public visibleRangeModal: boolean = false;
  public visibleDayModal: boolean = false;

  constructor(
    private guardsShiftsService: GuardsShiftsService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    public loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private guardsShiftsDatesService: GuardsShiftsDatesService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService
  ) {
    this.guardShift.color = "--color-primary";
    this.guardShiftFormGroup = this.formBuilder.formGroup<GuardShift>(this.guardShift) as RxFormGroup;
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Detalles del calendario de guardia");
    this.topbarService.addBreadcrumb("Turnos de guardia", "/guards-shifts");

    this.route.paramMap.subscribe((params: ParamMap) => {
      let id: string | null = params.get('id');
      if (id != null && id != '0') {
        this.loadGuardShift(id);
      }
    });
    this.allowWrite = this.loginService.hasPermission("GUARDS_SHIFTS.WRITE");
    this.allowDelete = this.loginService.hasPermission("GUARDS_SHIFTS.DELETE");
  }

  async loadGuardShift(id: any) {
    this.guardShift = await firstValueFrom(this.guardsShiftsService.get(id));
    let start = new Date();
    start.setHours(this.guardShift.startHour.split(":")[0], this.guardShift.startHour.split(":")[1], 0);
    this.guardShift.startHour = start;
    let end = new Date();
    end.setHours(this.guardShift.endHour.split(":")[0], this.guardShift.endHour.split(":")[1], 0);
    this.guardShift.endHour = end;
    let startHoliday = new Date();
    startHoliday.setHours(this.guardShift.startHourHoliday.split(":")[0], this.guardShift.startHourHoliday.split(":")[1], 0);
    this.guardShift.startHourHoliday = startHoliday;
    let endHoliday = new Date();
    endHoliday.setHours(this.guardShift.endHourHoliday.split(":")[0], this.guardShift.endHourHoliday.split(":")[1], 0);
    this.guardShift.endHourHoliday = endHoliday;
    let startWeekend = new Date();
    startWeekend.setHours(this.guardShift.startHourWeekend.split(":")[0], this.guardShift.startHourWeekend.split(":")[1], 0);
    this.guardShift.startHourWeekend = startWeekend;
    let endWeekend = new Date();
    endWeekend.setHours(this.guardShift.endHourWeekend.split(":")[0], this.guardShift.endHourWeekend.split(":")[1], 0);
    this.guardShift.endHourWeekend = endWeekend;
    this.guardShiftFormGroup.patchValue(this.guardShift);
  }


  async loadDates() {

    //Buscamos los del calendario    
    let filters = {
      guardShiftId: new Filter(FilterOperation.equals, 'guardShiftId', '', this.guardShift.id),
      fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '', this.fromDate!.startOf("year").toISOString()),
      toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', this.toDate!.toISOString()),
    };

    let params: IParamsCollection = {
      page: {
        size: 5000,
        number: 0
      },
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.guardsShiftsDatesService.all(params));

    this.guardShiftDates = response.data;
  }

  async save() {

    let valid = this.formValidationService.validateForm(this.guardShiftFormGroup);
    if (valid) {

      this.guardShift = Object.assign(this.guardShift, this.guardShiftFormGroup.value);
      this.guardShift.startHour = new Date(this.guardShift.startHour).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.guardShift.endHour = new Date(this.guardShift.endHour).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.guardShift.startHourHoliday = new Date(this.guardShift.startHourHoliday).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.guardShift.endHourHoliday = new Date(this.guardShift.endHourHoliday).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.guardShift.startHourWeekend = new Date(this.guardShift.startHourWeekend).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.guardShift.endHourWeekend = new Date(this.guardShift.endHourWeekend).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });

      let guardShift = await firstValueFrom(this.guardsShiftsService.save(this.guardShift));

      if (this.guardShift.id != "undefined" && this.guardShift.id != "") {
        this.router.navigate(['guards-shifts']);
      }

      this.loadGuardShift(guardShift.id!);

      this.messageService.add({ closable: true, severity: 'success', summary: "Turno de guardia guardado correctamente." });
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {

    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el turno de guardia " + this.guardShift.name + "?",
      header: "Eliminar turno de guardia",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.guardsShiftsService.delete(this.guardShift.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Turno de guardia eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }


  cancel() {
    this.router.navigate(['guards-shifts']);
  }

  async rangeSelected(data: any) {
    this.rangeStartDate = data.start;
    this.rangeEndDate = data.end;
    this.visibleRangeModal = true;
  }

  async saveRange() {
    if (typeof this.guardShift.id != "undefined" && this.guardShift.id != "") {      
      await firstValueFrom(this.guardsShiftsDatesService.saveGuardShiftDates(this.guardShift.id!, { startDate: this.rangeStartDate, endDate: this.rangeEndDate }));
      this.loadDates();
    }
  }

  async deleteRange() {
    if (typeof this.guardShift.id != "undefined" && this.guardShift.id != "") {
      await firstValueFrom(this.guardsShiftsDatesService.deleteGuardShiftDates(this.guardShift.id!, { startDate: this.rangeStartDate, endDate: this.rangeEndDate }));
      this.loadDates();
    }
  }

  async daySelected(data: any) {    
    this.rangeStartDate = data.date.date.startOf("day");
    this.rangeEndDate = moment(data.date.date).add(1, "day").startOf("day");
    this.visibleDayModal = true;
  }


  async saveDay() {
    if (typeof this.guardShift.id != "undefined" && this.guardShift.id != "") {      
      await firstValueFrom(this.guardsShiftsDatesService.saveGuardShiftDates(this.guardShift.id!, { startDate: this.rangeStartDate}));
      this.loadDates();
    }
  }

  yearChanged(data: any) {
    this.fromDate = data.first_date;
    this.toDate = data.end_date;
    this.loadDates();
  }

}
